import { generateUtilityClasses } from '@mui/material';

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const labelContainerClasses = generateUtilityClasses('LabelContainer', [
  'root',
  'content',
  'labelArea',
  'actions',
  'status',
  'links',
  'buttons',
]);
